/**
 * Map Firebase / Firestore auth errors to short user-facing copy.
 * Never return raw SDK messages (e.g. setDoc undefined field).
 */
export function getFriendlyAuthError(err, fallback = 'Something went wrong. Please try again.') {
  const code = err?.code || '';
  const message = String(err?.message || '');

  switch (code) {
    case 'auth/email-already-in-use':
      return 'An account with this email already exists. Try logging in instead.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/weak-password':
    case 'auth/password-does-not-meet-requirements':
      return 'Use at least 12 characters, with an uppercase letter and a symbol such as ! or ?.';
    case 'auth/user-not-found':
      return 'No account found with this email address.';
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Incorrect email or password. Please try again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.';
    case 'auth/popup-closed-by-user':
      return 'Sign-in was cancelled. Please try again.';
    case 'auth/popup-blocked':
      return 'Pop-up was blocked. Please allow pop-ups for this site.';
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with this email. Please log in instead.';
    case 'auth/operation-not-allowed':
      return 'This sign-in method is not available right now. Please try again later.';
    default:
      break;
  }

  if (
    message.includes('Unsupported field value: undefined')
    || message.includes('setDoc()')
    || message.includes('updateDoc()')
    || message.includes('Missing or insufficient permissions')
  ) {
    return 'We could not finish setting up your account. Please try again, or log in if you already registered.';
  }

  return fallback;
}
